import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=22c4d850&scoped=true"
import script from "./Schedule.vue?vue&type=script&lang=js"
export * from "./Schedule.vue?vue&type=script&lang=js"
import style0 from "./Schedule.vue?vue&type=style&index=0&id=22c4d850&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c4d850",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c4d850')) {
      api.createRecord('22c4d850', component.options)
    } else {
      api.reload('22c4d850', component.options)
    }
    module.hot.accept("./Schedule.vue?vue&type=template&id=22c4d850&scoped=true", function () {
      api.rerender('22c4d850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/Schedule.vue"
export default component.exports